import HtmlAttrId from 'client/components/core/Sidebar/components/Settings/options/HtmlAttrId'
import React from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { SidebarBottomPortal } from 'src/editor/layout/sidebar/settings/sidebar-bottom-portal'
import { CheckboxControl } from 'src/editor/shared/settings/checkbox-control'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { TextInputControl } from 'src/editor/shared/settings/controls/text-input-control'
import {
  FormCheckboxInterface,
  FormInterface,
  FormSubEntityTypeEnum,
} from 'src/shared/types/entities/form-interface'
import { useUpdateFormSubEntityProp } from '../../hooks/use-update-form-sub-entity-prop'
import { FormSubEntityCommonSettingsButtonLink } from './form-sub-entity-common-settings-button-link'

export const FormCheckboxSubEntitySettings = ({
  formEntity,
  checkboxSubEntity,
}: {
  formEntity: FormInterface
  checkboxSubEntity: FormCheckboxInterface
}) => {
  const updateProp = useUpdateFormSubEntityProp(formEntity, checkboxSubEntity)

  return (
    <>
      <TextInputControl
        update={updateProp('errorText')}
        value={checkboxSubEntity.errorText}
        wrapperProps={{
          labelText: 'settings_options.checkbox_message',
        }}
        disabled={checkboxSubEntity.optional}
      />
      <CheckboxControl
        label="entity_settings.explicit_consent.optional"
        tooltipText="entity_settings.explicit_consent.optional_popover"
        value={checkboxSubEntity.optional}
        update={updateProp('optional')}
      />

      <GroupTitle></GroupTitle>

      <ColorPickerControl
        update={updateProp('color')}
        mobileUpdate={updateProp('mobileColor')}
        color={checkboxSubEntity.color}
        mobileColor={checkboxSubEntity.mobileColor}
        label="text color"
      />
      <HtmlAttrId attrId={checkboxSubEntity.htmlAttrId} />

      <SidebarBottomPortal>
        <FormSubEntityCommonSettingsButtonLink
          formEntity={formEntity}
          commonSettingsType={FormSubEntityTypeEnum.Checkbox}
        />
      </SidebarBottomPortal>
    </>
  )
}
